import {
  DYNAMIC_COMPONENT_INIT,
  DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
  DYNAMIC_COMPONENT_INIT_WITH_STATE,
  COLLABORATION_REMOTE_DOCUMENT_UPDATE,
} from 'common/types';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {put, call, take, select, fork} from 'redux-saga/effects';
import ApiActions from 'go/actions/api';
import {
  isFemaUser,
  countDependenciesToLoad,
  buildParamString,
  checkIfDefinedNonNullAndNotEmptyString,
  isToggledOnDependency,
} from 'common/utils';
import {
  ENTITY_MAP,
  ENTITY_PAGE_TYPE_GRANT,
  ENTITY_PAGE_TYPE_SUBGRANT,
  ENTITY_PAGE_TYPE_SUBAPPLICATION,
  TOKEN_LOADED,
} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import {
  ENDPOINT_ORGANIZATION,
  ENDPOINT_OBLIGATION,
  ENDPOINT_VENDOR,
  ENDPOINT_GRANT,
} from 'common/endpoints';
import {delay} from 'redux-saga';

import goStore from 'go/store';

const dependencyMapping = {
  application: loadApplication,
  applicationsByOrg: loadApplicationsByOrgIdAndFOId,
  allocationsByFO: loadAllocationsByFoId,
  allocation: loadAllocationById,
  allocationEntities: loadAllocationEntities,
  allocationEntitiesByTypes: loadAllocationEntitiesByTypes,
  allocationPendingEntities: loadAllocationPendingEntities,
  communityLifeline: loadCommunityLifeline,
  hazardSources: loadHazardSources,
  fundingSources: loadfundingSources,
  fundingTypes: loadfundingTypes,
  structureTypes: loadStructureTypes,
  propertyOwnerTypes: loadPropertyOwnerTypes,
  propertyInventoryTypes: loadPropertyInventoryTypes,
  benefitCostTypes: loadBenefitCostTypes,
  mitigationActionTypes: loadMitigationActionTypes,
  landUseTypes: loadLandUseTypes,
  propertyFoundationTypes: loadPropertyFoundationTypes,
  floodZoneTypes: loadFloodZoneTypes,
  natureBasedSolutions: loadNatureBasedSolutions,
  subApplication: loadSubApplication,
  subApplicationWithConfigPath: loadSubApplicationWithConfigPath,
  subApplicationGrant: loadSubApplicationGrant,
  grant: loadGrant,
  grantIdByFOIdAndOrgId: loadGrantIdByFOIdAndOrgId,
  taskData: loadTaskByGrantIdEntityType,
  subApplicationsForGrant: loadSubApplicationsByGrantIdEntityType,
  subGrant: loadSubGrant,
  subGrantWithConfigPath: loadSubGrantWithConfigPath,
  organization: loadOrganization,
  subOrganizationBySubOrgId: loadSubOrganizationBySubOrgId,
  organizations: loadOrganizations,
  subOrganization: loadSubOrganization,
  program: loadProgram,
  fundingOpportunity: loadFundingOpportunity,
  fundingOpportunityV2: loadFundingOpportunityV2,
  foFundingOpportunityV2: loadFOFundingOpportunityV2,
  foFundingOpportunityV2WithParams: loadFundingOpportunityV2WithParams,
  fosByOrgAndSubOrg: loadFosByOrgAndSubOrg,
  programCategoryConfig: loadProgramCategoryConfig,
  foProgramCategoryConfig: loadFOProgramCategoryConfig,
  invoice: loadInvoice,
  subGrantInvoice: loadSubGrantInvoice,
  obligation: loadObligation,
  obligationStatus: loadObligationStatus,
  enhancedObligation: loadEnhancedObligation,
  approvedObligationAmount: loadApprovedObligationAmount,
  subGrantObligationAmountsByGrant: loadSubGrantObligationAmountsByGrant,
  closeout: loadCloseout,
  commitment: loadCommitment,
  commitmentDataForGrant: loadCommitmentDataForGrant,
  comment: loadComment,
  subComment: loadSubComment,
  rfaComment: loadRFAComment,
  riskAssessment: loadRiskAssessment,
  workflowTask: loadWorkflowTask,
  panelReview: loadPanelReview,
  scores: loadScores,
  panelReviewScoresV2: loadScoresV2,
  panelReviewSessionsV2: loadSessionsV2,
  panelReviewUserScoresV2: loadUserScoresV2,
  panelReviewFinalScoresV2: loadFinalScoresV2,
  panelReviewV2: loadPanelReviewV2,
  prescoreV2: loadPrescoreV2,
  fundingOpportunityData: loadFOData,
  awardRecommendation: loadAwardRecommendation,
  subAwardRecommendation: loadSubAwardRecommendation,
  subAmendmentRecommendation: loadSubAmendmentRecommendation,
  subAmendmentRecommendationsForSubGrant: loadSubAmendmentRecommendationsForSubGrant,
  legacyHMASubAmendmentRecommendationsForSubGrant:
    loadLegacyHMASubAmendmentRecommendationsForSubGrant,
  subAwardOrAmendmentRecommendation: loadSubAwardOrAmendmentRecommendation,
  workflowTasksForGrant: loadWorkflowTasksForGrant,
  workflowTasksForSubGrant: loadWorkflowTasksForSubGrant,
  panelReviewSessionEntityTasks: loadWorkflowTasksForSessionEntity,
  panelReviewSessionUserTasks: loadWorkflowTasksForSessionUserId,
  attachment: loadAttachment,
  applicationDynamicData: loadApplicationDynamicData,
  awardRecommendationDynamicData: loadAwardRecommendationDynamicData,
  rules: loadRules,
  templates: loadTemplates,
  subApplicationProgram: loadSubApplicationProgram,
  loadItemCodes: loadItemCodes,
  loadRefApplicantType: loadRefApplicantType,
  loadStates: loadStates,
  user: loadUser,
  amendment: loadAmendment,
  loadProgramCategories: loadProgramCategories,
  payment: loadPayment,
  financialReport: loadFinancialReport,
  bsirReport: loadBSIRReport,
  ehp: loadEhpEntity,
  ehpReview: loadEhpReviewEntity,
  ehpReviewPassthrough: loadEhpReviewEntityPassthrough,
  payments: loadPayments,
  paymentsForSubGrant: loadPaymentsForSubGrant,
  amendments: loadAmendments,
  grantApplicationExtensions: loadGrantAppExtensions,
  vendor: loadVendorData,
  financialReports: loadFinancialReports,
  bsirReports: loadBSIRReports,
  externalTasksForGrant: loadExternalTasksForGrant,
  externalTasksForSubGrant: loadExternalTasksForSubGrant,
  applicationLinkData: loadApplicationLinkData,
  rfisForAmendment: loadRfisForAmendment,
  panelReviewSession: loadSessionData,
  panelReviewSessionEntity: loadSessionEntity,
  panelReviewReviewer: loadReviewerData,
  panelReviewReviewerNames: loadUserNames,
  panelReviewAssignedEntities: loadSessionEntities,
  panelReviewAliases: loadPanelReviewAliases,
  panelReviewGroup: loadPanelGroupData,
  panelReviewerGroups: loadPanelReviewersGroupData,
  performanceProgressReport: loadPerformanceProgressReport,
  performanceProgressReports: loadPerformanceProgressReports,
  closeoutReport: loadCloseoutReport,
  closeoutReports: loadCloseoutReports,
  subCloseoutReport: loadSubCloseoutReport,
  subCloseoutReports: loadSubCloseoutReports,
  subCloseoutRecommendation: loadSubCloseoutRecommendation,
  closeoutRecommendation: loadCloseoutRecommendation,
  programmaticCloseoutReview: loadProgrammaticCloseoutReview,
  programmaticCloseoutReviews: loadProgrammaticCloseoutReviews,
  rfi: loadRfi,
  rfis: loadRfis,
  rof: loadRof,
  rofs: loadRofs,
  returnOfFund: loadReturnOfFund,
  rofsForSubGrant: loadRofsForSubGrant,
  rofsForGrant: loadRofsForGrant,
  rfisForGrant: loadRfisForGrant,
  rfisForParentEntity: loadRfisForParentEntity,
  activeRfisForParentEntity: loadActiveRfisForParentEntity,
  panelReviewEntity: loadPanelReviewEntity,
  disasterAreas: loadDisasterAreas,
  disaster: loadDisasterById,
  subAwardRecommendationsForGrant: loadSubAwardRecommendationsForGrant,
  awardRecommendationForFO: loadAwardRecommendationForFO,
  subAwardRecommendationForFO: loadSubAwardRecommendationForFO,
  subAmendmentRecommendationsForGrant: loadSubAmendmentRecommendationsForGrant,
  subGrantsForGrant: loadSubGrantsForGrant,
  subOrganizationsForGrant: loadSubOrganizationsForGrant,
  subCloseoutReportsForGrant: loadSubCloseoutReportsForGrant,
  subCloseoutRecommendationsForGrant: loadSubCloseoutRecommendationsForGrant,
  fundingOpportunityOrganizationData: loadFundingOpportunityOrganizationData,
  ehpReviewsForSubGrant: loadEhpReviewsForSubGrant,
  fundingOpportunityDraft: loadFundingOpportunityDraft,
  subRecipientMgmtCost: loadsubRecipientMgmtCost,
  subCloseoutRecommendationForGrant: loadSubCloseoutRecommendationForGrant,
  programDefaultConfig: loadProgramDefaultConfig,
  subApplicationFromSubGrantId: loadSubApplicationFromSubGrantId,
};

export default function* dependencySaga() {
  yield take([
    DYNAMIC_COMPONENT_INIT,
    DYNAMIC_COMPONENT_INIT_WITH_STATE,
    DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
    COLLABORATION_REMOTE_DOCUMENT_UPDATE,
  ]);
  yield fork(waitForDependencyChangeGate);
  yield call(dependencySaga);
}

export function* waitForDependencyChangeGate() {
  const state = yield select();
  const toggles = _.get(state, 'toggles.toggles');
  const isWaitForContextToggled = _.includes(toggles, 'waitForContextBeforeDependencies');
  if (isWaitForContextToggled) {
    const userId = _.get(state, 'auth.token.userId');
    const profilePresent = !!_.get(state, 'profile.emailAdr');
    if (userId && profilePresent) {
      yield fork(waitForDependencyChange);
      return;
    }
    // we don't have everything, loop back around.
    if (userId && !profilePresent) {
      yield put(ApiActions.profile.getUser(userId));
    }
    yield delay(1000);
    yield fork(waitForDependencyChangeGate);
  } else {
    yield fork(waitForDependencyChange);
  }
}

export function* waitForDependencyChange() {
  const state = yield select();
  const {config} = state.dynamicComponent;
  const toggles = _.get(state, 'toggles.toggles');
  const numDependenciesLoaded = _.get(
    state,
    'dynamicComponent.context.numLoadedSuccessfully'
  );

  const dependencies = _.get(
    config,
    'dependencies',
    _.get(config, 'payload.dependencies', [])
  );
  const dependenciesToLoad = countDependenciesToLoad(
    dependencies,
    isFemaUser(_.get(state, 'auth.permissions')),
    toggles
  );

  if (numDependenciesLoaded === dependenciesToLoad) {
    yield put(DynamicComponentActions.validateConfigRules());
  }
  for (var i = 0; i < dependencies.length; i++) {
    yield call(pickDependencyToLoad, dependencies[i], state);
  }
}

// Ensure to check if the dependency is loaded already in the if statement
//TODO create object with dependency loader object that is keyed off of properties grab function and execute
export function* pickDependencyToLoad(dependency, state, {toggle} = {}) {
  const {data} = state.dynamicComponent;
  const auth = _.get(state, 'auth');
  const toggles = _.get(state, 'toggles');
  const token = _.get(auth, 'token');

  let context = Object.assign({}, state.dynamicComponent.context);
  context.auth = auth;
  context.toggles = toggles;
  let loader;
  if (typeof dependency === 'object') {
    loader = dependencyMapping[dependency.dependency];
  } else {
    loader = dependencyMapping[dependency];
  }
  let optional = dependency.optional ? dependency.optional : false;
  if (loader !== undefined) {
    const toggles = _.get(context, 'toggles.toggles');
    let isToggledOnDependencyFlag = isToggledOnDependency(toggle, toggles, null);
    if (isToggledOnDependencyFlag) {
      yield loader(
        data,
        context,
        token,
        optional,
        _.get(dependency, 'dependencyConfig', _.get(dependency, 'config'))
      );
    }
  }
}

// does the redux interaction for all methods below
function loadDependency() {
  return put(ApiActions.dependencies.get(...arguments));
}

function forceSucceedDependency(objectType) {
  return goStore.store.dispatch({
    type: DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS,
    meta: {objectType: objectType},
    payload: {isLoading: false},
  });
}

function loadApplication(data, context, token, optional) {
  if (
    (!_.isEmpty(_.toString(_.get(_.get(data, 0), 'applicationId'))) ||
      _.get(context, 'workflowTask.processVariables.grantId')) &&
    _.isEmpty(_.toString(context.applicationDynamicData))
  ) {
    const applicationId =
      _.get(_.get(data, 0), 'applicationId') ||
      _.get(context, 'workflowTask.processVariables.grantId');

    return loadDependency(
      'applicationDynamicData',
      '',
      token,
      optional,
      `?grantId=${applicationId}&entityType=application`
    );
  }
}

function loadAllocationsByFoId(data, context, token, optional, config) {
  const foId = _.get(
    data,
    'fundingOpportunityId',
    _.get(
      context,
      'grant.fundingOpportunityId',
      _.get(context, 'subGrant.fundingOpportunityId')
    )
  );
  if (!_.isEmpty(_.toString(foId)) && _.isEmpty(_.toString(context.allocationsByFO))) {
    return loadDependency(
      'allocationsByFO',
      '',
      token,
      optional,
      `?fundingOpportunityId=${foId}`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadAllocationById(data, context, token, optional) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  if (!_.isEmpty(_.toString(allocationId)) && _.isEmpty(_.toString(context.allocation))) {
    return loadDependency('allocation', '', token, optional, `${allocationId}`);
  }
}

function loadAllocationEntities(data, context, token, optional, config) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');
  const entityType = !_.isEmpty(_.toString(config))
    ? config.dynamicParams.entityType
    : 'subAwardRecommendation';

  if (
    !_.isEmpty(_.toString(allocationId)) &&
    !_.isEmpty(_.toString(fundingOpportunityId)) &&
    !_.isEmpty(_.toString(entityType)) &&
    _.isEmpty(_.toString(context.allocationEntities))
  ) {
    return loadDependency(
      'allocationEntities',
      '',
      token,
      optional,
      `fundingOpportunityId/${fundingOpportunityId}/allocationId/${allocationId}/entityType/${entityType}`
    );
  }
}

function loadAllocationEntitiesByTypes(data, context, token, optional, config) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );

  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');
  const entityTypes = !_.isEmpty(_.toString(config))
    ? _.join(_.get(config, 'dynamicParams.entityTypes'), ',')
    : 'subAwardRecommendation';

  if (
    !_.isEmpty(_.toString(allocationId)) &&
    !_.isEmpty(_.toString(fundingOpportunityId)) &&
    !_.isEmpty(_.toString(entityTypes)) &&
    _.isEmpty(_.toString(context.allocationEntitiesByTypes))
  ) {
    return loadDependency(
      'allocationEntitiesByTypes',
      '',
      token,
      optional,
      `fundingOpportunityId/${fundingOpportunityId}/allocationId/${allocationId}/entityTypes/${entityTypes}`
    );
  }
}

function loadAllocationPendingEntities(data, context, token, optional) {
  const allocationId = _.get(
    data,
    'allocationId',
    _.get(
      data,
      'sysAllocationId',
      _.get(context, 'workflowTask.processVariables.allocationId')
    )
  );
  if (
    !_.isEmpty(_.toString(allocationId)) &&
    _.isEmpty(_.toString(context.allocationPendingEntities))
  ) {
    return loadDependency(
      'allocationPendingEntities',
      '',
      token,
      optional,
      `allocation/${allocationId}/entities`
    );
  }
}

function loadRfisForAmendment(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'rfisForAmendment'
  );
}

function loadRfisForParentEntity(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'rfisForParentEntity'
  );
}

function loadActiveRfisForParentEntity(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'activeRfisForParentEntity'
  );
}

function loadApplicationLinkData(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'applicationLinkData'
  );
}

function loadLegacyHMASubAmendmentRecommendationsForSubGrant(
  data,
  context,
  token,
  optional,
  config
) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'legacyHMASubAmendmentRecommendationsForSubGrant'
  );
}

function loadCommitmentDataForGrant(data, context, token, optional, config) {
  // subgrant level commitment data
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'commitmentDataForGrant'
  );
}

function loadFundingOpportunityV2WithParams(data, context, token, optional, config) {
  const fundingOpportunity = context['fundingOpportunityV2'];
  if (_.isEmpty(_.toString(fundingOpportunity))) {
    return loadDependencyWithParams(
      data,
      context,
      token,
      optional,
      config,
      'fundingOpportunityV2'
    );
  }
}

function loadDependencyWithParams(data, context, token, optional, config, dependency) {
  const payload = {...context, data};
  const Id = _.get(payload, config.id);
  let extra = '?';
  const url = config.url ? config.url : '';
  if (config) {
    let params = [];
    _.each(config.dynamicParams, (value, key) => {
      // raw value let's you define an exact value for your parameter without needing it to exist in context
      if (value.rawValue) {
        params.push(`${key}=` + value.rawValue);
      } else {
        params.push(`${key}=` + _.get(context, value, value));
      }
    });
    extra = extra + _.join(params, '&');
  }
  if (!_.isEmpty(_.toString(Id)) && _.isEmpty(_.toString(context[dependency]))) {
    return loadDependency(dependency, url, token, optional, extra);
  }
}

function loadGrantIdByFOIdAndOrgId(data, context, token, optional) {
  const organizationId = _.get(data, 'organizationId');
  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');

  if (
    !_.isEmpty(_.toString(organizationId)) &&
    !_.isEmpty(_.toString(fundingOpportunityId)) &&
    _.isEmpty(_.toString(context.grantIdByFOIdAndOrgId))
  ) {
    return loadDependency(
      'grantIdByFOIdAndOrgId',
      '',
      token,
      optional,
      `entities/grant-id?fundingOpportunityId=${fundingOpportunityId}&organizationId=${organizationId}&entityType=grant`
    );
  }
}

function loadApplicationsByOrgIdAndFOId(data, context, token, optional) {
  const organizationId = _.get(data, 'organizationId');
  const fundingOpportunityId = _.get(data, 'fundingOpportunityId');

  if (
    !_.isEmpty(_.toString(organizationId)) &&
    !_.isEmpty(_.toString(fundingOpportunityId)) &&
    _.isEmpty(_.toString(context.applicationsByOrg))
  ) {
    return loadDependency(
      'applicationsByOrg',
      '',
      token,
      optional,
      `organization/${organizationId}/fundingOpportunityId/${fundingOpportunityId}/entityType/application`
    );
  }
}

function loadSubApplicationGrant(data, context, token, optional) {
  const subAppEntityId =
    _.get(data, 'entityType') === 'subApplication'
      ? _.get(data, 'entityId')
      : _.get(data, 'entityType') === 'completeRfiUserTask'
      ? _.get(data, 'subGrantId')
      : _.get(
          context,
          'workflowTask.processVariables.subApplication.subGrantId',
          _.get(
            context,
            'workflowTask.processVariables.subGrantId',
            _.get(
              context,
              'workflowTask.processVariables.entityId',
              _.get(data, 'subGrantId')
            )
          )
        );

  const grantId = _.get(context, 'subGrant.grantId', _.get(context, 'grant.entityId'));

  if (
    !_.isEmpty(_.toString(subAppEntityId)) &&
    !_.isEmpty(_.toString(grantId)) &&
    _.isEmpty(_.toString(context.subApplicationGrant))
  ) {
    return loadDependency(
      'subApplicationGrant',
      '',
      token,
      optional,
      `first-entity?entityType=subApplication&subGrantId=${subAppEntityId}`
    );
  }
}
function loadSubApplication(data, context, token, optional) {
  const subAppEntityId =
    _.get(data, 'entityType') === 'subApplication'
      ? _.get(data, 'entityId')
      : _.get(context, 'workflowTask.processVariables.entityId') ||
        _.get(context, 'workflowTask.processVariables.subApplication.subGrantId') ||
        _.get(data, 'subGrantId');

  if (
    !_.isEmpty(_.toString(subAppEntityId)) &&
    _.isEmpty(_.toString(context.subApplication))
  ) {
    return loadDependency('subApplication', subAppEntityId, token, optional);
  }
}
function loadSubApplicationWithConfigPath(data, context, token, optional, config) {
  const subAppEntityId = _.get(
    _.get(config, 'root') === 'context' ? context : data,
    _.get(config, 'dataPath')
  );

  if (
    !_.isEmpty(_.toString(subAppEntityId)) &&
    _.isEmpty(_.toString(context.subApplication))
  ) {
    return loadDependency('subApplication', subAppEntityId, token, optional);
  }
}

function loadCommunityLifeline(data, context, token, optional) {
  const id = 'codes/COMMUNITY_LIFELINE';
  if (_.isEmpty(_.toString(context.communityLifeline))) {
    return loadDependency('communityLifeline', id, token, optional);
  }
}

function loadHazardSources(data, context, token, optional) {
  const id = 'codes/HAZARD_SOURCE';
  if (_.isEmpty(_.toString(context.hazardSources))) {
    return loadDependency('hazardSources', id, token, optional);
  }
}

function loadfundingSources(data, context, token, optional) {
  const id = 'codes/FUNDING_SOURCE';
  if (_.isEmpty(_.toString(context.fundingSources))) {
    return loadDependency('fundingSources', id, token, optional);
  }
}

function loadfundingTypes(data, context, token, optional) {
  const id = 'codes/FUNDING_TYPE';
  if (_.isEmpty(_.toString(context.fundingTypes))) {
    return loadDependency('fundingTypes', id, token, optional);
  }
}

function loadStructureTypes(data, context, token, optional) {
  const id = 'codes/STRUCTURE_TYPE';
  if (_.isEmpty(_.toString(context.structureTypes))) {
    return loadDependency('structureTypes', id, token, optional);
  }
}

function loadPropertyOwnerTypes(data, context, token, optional) {
  const id = 'codes/PROPERTY_OWNER_TYPE';
  if (_.isEmpty(_.toString(context.propertyOwnerTypes))) {
    return loadDependency('propertyOwnerTypes', id, token, optional);
  }
}

function loadPropertyInventoryTypes(data, context, token, optional) {
  const id = 'codes/PROPERTY_INVENTORY_TYPE';
  if (_.isEmpty(_.toString(context.propertyInventoryTypes))) {
    return loadDependency('propertyInventoryTypes', id, token, optional);
  }
}

function loadBenefitCostTypes(data, context, token, optional) {
  const id = 'codes/BENEFIT_COST_TYPE';
  if (_.isEmpty(_.toString(context.benefitCostTypes))) {
    return loadDependency('benefitCostTypes', id, token, optional);
  }
}

function loadMitigationActionTypes(data, context, token, optional) {
  const id = 'codes/MITIGATION_ACTION';
  if (_.isEmpty(_.toString(context.mitigationActionTypes))) {
    return loadDependency('mitigationActionTypes', id, token, optional);
  }
}

function loadLandUseTypes(data, context, token, optional) {
  const id = 'codes/INVENTORY_LAND_USE';
  if (_.isEmpty(_.toString(context.landUseTypes))) {
    return loadDependency('landUseTypes', id, token, optional);
  }
}

function loadPropertyFoundationTypes(data, context, token, optional) {
  const id = 'codes/PROPERTY_FOUNDATION_TYPE';
  if (_.isEmpty(_.toString(context.propertyFoundationTypes))) {
    return loadDependency('propertyFoundationTypes', id, token, optional);
  }
}

function loadFloodZoneTypes(data, context, token, optional) {
  const id = 'codes/FLOOD_ZONE_TYPE';
  if (_.isEmpty(_.toString(context.floodZoneTypes))) {
    return loadDependency('floodZoneTypes', id, token, optional);
  }
}

function loadNatureBasedSolutions(data, context, token, optional) {
  const id = 'codes/NATURE_BASED_SOLUTION';
  if (_.isEmpty(_.toString(context.natureBasedSolutions))) {
    return loadDependency('natureBasedSolutions', id, token, optional);
  }
}

function loadProgramCategories(data, context, token, optional) {
  const id = 'codes/PROGRAM_CATEGORY';
  if (_.isEmpty(_.toString(context.loadProgramCategories))) {
    return loadDependency('loadProgramCategories', id, token, optional);
  }
}

// TODO, point at dynamicData instead of grant svc
function loadGrant(data, context, token, optional, config) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(data, 'payload.grantId') || // todo, remove this condition
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'subGrant.grantId');
  if (!_.isEmpty(_.toString(grantId)) && _.isEmpty(_.toString(context.grant))) {
    return loadDependency(
      'grant',
      `entities/first-entity?grantId=${grantId}&entityType=grant`,
      token,
      optional
    );
  }
}

function loadTaskByGrantIdEntityType(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'applicationDynamicData.grantId');
  const entityType = _.get(optional, 'entityType');

  if (
    !_.isEmpty(_.toString(grantId)) &&
    !_.isEmpty(_.toString(entityType)) &&
    _.isEmpty(_.toString(context.taskData))
  ) {
    return loadDependency(
      'taskData',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=${entityType}`
    );
  }
}

function loadSubApplicationsByGrantIdEntityType(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subApplicationsForGrant))) {
    return loadDependency(
      'subApplicationsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subApplication`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubGrantWithConfigPath(data, context, token, optional, config) {
  const subGrantId = _.get(
    _.get(config, 'root') === 'context' ? context : data,
    _.get(config, 'dataPath')
  );
  if (!_.isEmpty(_.toString(subGrantId)) && _.isEmpty(_.toString(context.subGrant))) {
    return loadDependency('subGrant', subGrantId, token, optional);
  }
}
function loadSubGrant(data, context, token, optional, config) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subApplication.subGrantId');

  if (!_.isEmpty(_.toString(subGrantId)) && _.isEmpty(_.toString(context.subGrant))) {
    return loadDependency('subGrant', subGrantId, token, optional);
  }
}

function loadSubGrantsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subGrantsForGrant))) {
    return loadDependency(
      'subGrantsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subGrant`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubCloseoutReportsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subCloseoutReportsForGrant))) {
    return loadDependency(
      'subCloseoutReportsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subCloseoutReport`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubCloseoutRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subCloseoutRecommendationsForGrant))) {
    return loadDependency(
      'subCloseoutRecommendationsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subCloseoutRecommendation`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadSubOrganization(data, context, token, optional) {
  const permissions = _.get(context, 'auth.permissions');
  let orgList = [];
  permissions.forEach((permission) => {
    let permArray = permission.split(':');
    let type = permArray[0];
    if (
      type === ENTITY_MAP.PROGRAM_ORGANIZATION.code ||
      type === ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
    ) {
      orgList.push(permArray[1].split('_')[0]);
    }
  });
  orgList = _.uniq(orgList);
  const orgId =
    _.get(data, 'organizationId', _.get(context, 'subApplicationGrant.organizationId')) ||
    _.get(context, 'grant.organizationId') ||
    _.get(context, 'subApplication.organizationId');
  const subOrgId =
    _.get(data, 'subOrganizationId') ||
    _.get(context, 'subApplication.subOrganizationId') ||
    _.get(context, 'subApplicationGrant.subOrganizationId');
  if (
    !_.isUndefined(subOrgId) &&
    _.isNumber(_.toNumber(subOrgId)) &&
    !_.includes(orgList, subOrgId) &&
    _.isEmpty(_.toString(context.subOrganization))
  ) {
    const endPointToUse = `${orgId}/suborganizations/${subOrgId}`;
    return loadDependency('subOrganization', endPointToUse, token, optional);
  } else if (
    !_.isUndefined(orgId) &&
    _.isNumber(_.toNumber(orgId)) &&
    !_.isUndefined(subOrgId) &&
    _.isNumber(_.toNumber(subOrgId)) &&
    _.isEmpty(_.toString(context.subOrganization))
  ) {
    return loadDependency('subOrganization', orgId, token, optional);
  }
}

function loadOrganization(data, context, token, optional) {
  let orgId =
    _.get(
      context,
      'awardRecommendation.organizationId',
      _.get(context, 'grant.organizationId')
    ) ||
    _.get(data, 'organizationId') ||
    _.get(context, 'subApplicationGrant.organizationId') ||
    _.get(context, 'workflowTask.processVariables.organizationId');
  if (!_.isEmpty(_.toString(orgId)) && _.isEmpty(_.toString(context.organization))) {
    return loadDependency('organization', orgId, token, optional);
  }
}

function loadSubOrganizationBySubOrgId(data, context, token, optional, config) {
  const entity = _.get(config, 'root') === 'context' ? context : data;
  var dataPath = _.get(config, 'dataPath');

  var subOrgId = _.get(entity, dataPath);

  // Handles different attribute names for sub-organization id being a potential cause for
  // an undefined subOrgId.
  if (_.isEmpty(_.toString(subOrgId))) {
    var replace = false;
    if (dataPath.includes('subOrgId')) {
      dataPath = dataPath.replace('subOrgId', 'subOrganizationId');
      replace = true;
    } else if (dataPath.includes('subOrganizationId')) {
      dataPath = dataPath.replace('subOrganizationId', 'subOrgId');
      replace = true;
    }
    if (replace) {
      subOrgId = _.get(entity, dataPath);
    }
  }

  if (
    !_.isEmpty(_.toString(subOrgId)) &&
    _.isEmpty(_.toString(context.subOrganizationBySubOrgId))
  ) {
    return loadDependency('subOrganizationBySubOrgId', subOrgId, token, optional);
  }
}

function loadSubOrganizationsForGrant(data, context, token, optional) {
  const entities = _.get(
    context,
    'subGrantsForGrant.payload',
    _.get(context, 'subAwardRecommendationsForGrant.payload') ||
      _.get(context, 'subAmendmentRecommendationsForGrant.payload') ||
      _.get(context, 'commitmentDataForGrant.items')
  );
  if (
    entities &&
    !entities.loading &&
    _.isEmpty(_.toString(context.subOrganizationsForGrant))
  ) {
    let subOrgIds = _.map(entities, (entity) => {
      return _.get(entity, 'subOrganizationId');
    });
    let ids = _.map(
      _.filter(subOrgIds, (subOrgId) => checkIfDefinedNonNullAndNotEmptyString(subOrgId)),
      _.toNumber
    );
    if (!_.isEmpty(ids)) {
      return loadDependency(
        'subOrganizationsForGrant',
        `?organizationIds=${ids}`,
        token,
        optional
      );
    }
  }
}

function loadOrganizations(data, context, token, optional) {
  const permissions = _.get(context, 'auth.permissions');
  let orgList = [];
  permissions.forEach((permission) => {
    let permArray = permission.split(':');
    let type = permArray[0];
    if (
      type === ENTITY_MAP.ORGANIZATION.code ||
      type === ENTITY_MAP.PROGRAM_ORGANIZATION.code
    ) {
      orgList.push(permArray[1].split('_')[0]);
    }
  });
  orgList = _.uniq(orgList);
  if (!_.isEmpty(orgList) && _.isEmpty(_.toString(context.organizations))) {
    return loadDependency(
      'organizations',
      `?organizationIds=${orgList}`,
      token,
      optional,
      '',
      {
        method: 'GET',
      }
    );
  }
}

function loadProgram(data, context, token, optional) {
  const programId = _.get(
    data,
    'programId',
    _.get(context, 'grant.programId', _.get(context, 'fundingOpportunityData.programId'))
  );
  if (!_.isEmpty(_.toString(programId)) && _.isEmpty(_.toString(context.program))) {
    return loadDependency('program', programId, token, optional);
  }
}

function loadProgramDefaultConfig(data, context, token, optional) {
  const programId = _.get(
    data,
    'programId',
    _.get(
      context,
      'grant.programId',
      _.get(
        context,
        'fundingOpportunityData.programId',
        _.get(context, 'program.programId')
      )
    )
  );
  if (
    !_.isEmpty(_.toString(programId)) &&
    _.isEmpty(_.toString(context.programDefaultConfig))
  ) {
    return loadDependency(
      'programDefaultConfig',
      programId,
      token,
      optional,
      '?searchParams=""'
    );
  }
}

function loadFundingOpportunity(data, context, token, optional) {
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(context, 'panelReviewSession.fundingOpportunityId');

  let hasOrgInfo =
    _.has(context, 'grant.payload.organizationInformation') ||
    _.has(context, 'applicationDynamicData.payload.organizationInformation');

  if (
    fundingOpportunityId &&
    hasOrgInfo &&
    _.isEmpty(_.toString(context.fundingOpportunity))
  ) {
    let eligibleApplicantType = _.get(
      context,
      'grant.payload.organizationInformation.type',
      _.get(context, 'applicationDynamicData.payload.organizationInformation.type')
    );
    let isMicrogrant = _.get(
      context,
      'grant.payload.program.isMicrogrant',
      _.get(context, 'applicationDynamicData.payload.requestInformation.isMicroGrant')
    );
    let fundingStream = _.get(
      context,
      'grant.payload.program.fundingStream',
      _.get(context, 'applicationDynamicData.payload.requestInformation.fundingStream')
    );
    return loadDependency(
      'fundingOpportunity',
      fundingOpportunityId,
      token,
      optional,
      '/config?eligibleApplicantType=' +
        encodeURI(eligibleApplicantType) +
        '&fundingStream=' +
        encodeURI(fundingStream) +
        '&isAvailableForMicrogrant=' +
        isMicrogrant
    );
  } else if (
    fundingOpportunityId &&
    _.isEmpty(_.toString(context.fundingOpportunity)) &&
    context.panelReviewSession
  ) {
    return loadDependency('fundingOpportunity', fundingOpportunityId, token);
  }
}

function loadFundingOpportunityV2(data, context, token, optional) {
  let configType = 'fo';
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(data, 'payload.fundingOpportunity') ||
    _.get(context, 'subApplicationGrant.fundingOpportunityId') ||
    _.get(data, 'fundingOpportunityId') ||
    _.get(context, 'workflowTask.processVariables.fundingOpportunityId');

  if (
    !(optional && optional.skipSubAppFOConfig) &&
    'subApplication' === _.get(data, 'entityType')
  ) {
    configType = 'pc';
    fundingOpportunityId = _.get(data, 'categoryId');
  }
  if (
    !(optional && optional.skipSubAppFOConfig) &&
    !_.isEmpty(_.toString(context.subApplication)) &&
    'subApplication' === context.subApplication.entityType
  ) {
    configType = 'pc';
    fundingOpportunityId = _.get(context, 'subApplication.categoryId');
  }

  if (fundingOpportunityId && _.isEmpty(_.toString(context.fundingOpportunityV2))) {
    return loadDependency(
      'fundingOpportunityV2',
      `configs/${configType}/${fundingOpportunityId}/objectDefinition/fundingOpportunityConfig`,
      token,
      optional
    );
  }
}

function loadFOFundingOpportunityV2(data, context, token, optional) {
  let configType = 'fo';
  let fundingOpportunityId =
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(context, 'subApplicationGrant.fundingOpportunityId') ||
    _.get(data, 'fundingOpportunityId');

  if (fundingOpportunityId && _.isEmpty(_.toString(context.fundingOpportunityV2))) {
    return loadDependency(
      'fundingOpportunityV2',
      `configs/${configType}/${fundingOpportunityId}/objectDefinition/fundingOpportunityConfig`,
      token,
      optional
    );
  }
}

function loadFosByOrgAndSubOrg(data, context, token, optional) {
  const organizationId =
    _.get(context, 'subApplication.organizationId') ||
    _.get(context, 'subApplicationGrant.organizationId') ||
    _.get(data, 'organizationId');

  const subOrgId =
    _.get(context, 'subApplication.subOrganizationId') ||
    _.get(context, 'subApplicationGrant.subOrganizationId') ||
    _.get(data, 'subOrganizationId');

  if (organizationId && subOrgId && _.isEmpty(_.toString(context.fosByOrgAndSubOrg))) {
    return loadDependency(
      'fosByOrgAndSubOrg',
      `?organizationId=${organizationId}&subOrgId=${subOrgId}`,
      token,
      optional
    );
  }
}

function loadGrantAppExtensions(data, context, token, optional) {
  // const programId = _.get(data, 'programId', _.get(context, 'grant.programId'));
  if (
    !_.isEmpty(_.toString(data.grantId)) &&
    _.isEmpty(_.toString(context.grantApplicationExtensions))
  ) {
    return loadDependency(
      'grantApplicationExtensions',
      `?grantId=${data.grantId}`,
      token,
      optional
    );
  }
}

function loadProgramCategoryConfig(data, context, token, optional) {
  let categoryId =
    _.get(context, 'grant.categoryId') ||
    _.get(data, 'payload.categoryId') ||
    _.get(data, 'categoryId') ||
    _.get(context, 'subApplicationGrant.categoryId') ||
    _.get(context, 'subApplication.categoryId') ||
    _.get(optional, 'categoryId');

  if (categoryId && _.isEmpty(_.toString(context.programCategoryConfig))) {
    return loadDependency(
      'programCategoryConfig',
      `configs/pc/${categoryId}/pcConfig`,
      token,
      false
    );
  }
}

function loadFOProgramCategoryConfig(data, context, token, optional) {
  const fundingOpportunityId =
    _.get(data, 'fundingOpportunityId') ||
    _.get(context, 'grant.fundingOpportunityId') ||
    _.get(context, 'subGrant.fundingOpportunityId') ||
    _.get(context, 'workflowTask.processVariables.fundingOpportunityId');

  const extra = !_.isEmpty(optional) ? `?contextParams=${optional}` : '';
  if (fundingOpportunityId && _.isEmpty(_.toString(context.programCategoryConfig))) {
    return loadDependency(
      'programCategoryConfig',
      `configs/fo/${fundingOpportunityId}/pcConfig${extra}`,
      token,
      false
    );
  }
}

function loadInvoice(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(context.grant)) &&
    context.grant.grantId &&
    _.isEmpty(_.toString(context.invoice))
  ) {
    return loadDependency(
      'invoice',
      `summary?grantId=${context.grant.grantId}`,
      token,
      optional
    );
  }
}

function loadSubGrantInvoice(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(context.grant)) &&
    context.grant.grantId &&
    !_.isEmpty(_.toString(context.subGrant)) &&
    context.subGrant.entityId &&
    _.isEmpty(_.toString(context.invoice))
  ) {
    return loadDependency(
      'invoice',
      `summary?grantId=${context.grant.grantId}&subGrantId=${context.subGrant.entityId}`,
      token,
      optional
    );
  }
}

function loadAttachment(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(context.grant)) &&
    _.isEmpty(_.toString(context.attachment))
  ) {
    return loadDependency('attachment', context.grant.grantId, token, optional);
  }
}

function loadObligation(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(_.get(context, 'grant.grantId'))) &&
    _.isEmpty(_.toString(context.obligation))
  ) {
    const subGrantId = _.get(context, 'subGrant.subGrantId');
    const query = subGrantId
      ? `availableObligations?grantId=${context.grant.grantId}&subGrantId=${subGrantId}`
      : `availableObligations?grantId=${context.grant.grantId}`;
    return loadDependency('obligation', query, token, optional);
  }
}

function loadEnhancedObligation(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(_.get(context, 'grant.grantId'))) &&
    _.isEmpty(_.toString(context.obligation))
  ) {
    return loadDependency(
      'obligation',
      `find?grantId=${context.grant.grantId}`,
      token,
      optional
    );
  }
}

function loadObligationStatus(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(_.get(context, 'grant.grantId'))) &&
    _.isEmpty(_.toString(context.obligationStatus))
  ) {
    return loadDependency(
      'obligationStatus',
      `obligationDocumentStatus/grant/${context.grant.grantId}`,
      token,
      optional
    );
  }
}

function loadSubGrantObligationAmountsByGrant(data, context, token, optional) {
  if (
    !_.isEmpty(_.toString(_.get(context, 'grant.grantId'))) &&
    _.isEmpty(_.toString(context.subGrantObligationAmountsByGrant))
  ) {
    return loadDependency(
      'subGrantObligationAmountsByGrant',
      `totalObligationAmounts/subGrants/${context.grant.grantId}`,
      token,
      optional
    );
  }
}

function loadApprovedObligationAmount(data, context, token, optional, config) {
  if (_.isEmpty(_.toString(context.approvedObligationAmount))) {
    let entityType;
    if (config && config.entityType) {
      entityType = config.entityType;
    } else {
      entityType = _.get(data, 'subGrantId') ? 'subGrant' : 'grant';
    }
    let entityId =
      entityType === 'grant' ? _.get(data, 'grantId') : _.get(data, 'subGrantId');

    if (!_.isEmpty(entityId)) {
      return loadDependency(
        'approvedObligationAmount',
        `approvedAmount?${entityType}Id=${entityId}`,
        token,
        optional
      );
    }
  } else {
  }
}

function loadCloseout(data, context, token, optional) {
  const closeoutId = data.parentId || _.get(context, 'grant.closeoutId');
  if (_.isEmpty(_.toString(context.closeout)) && closeoutId) {
    return loadDependency('closeout', closeoutId, token, optional);
  }
}

function loadCommitment(data, context, token, optional) {
  const commitmentNumber = _.get(
    context,
    'amendment.payload.commitment.commitmentNumberId',
    _.get(
      context,
      'awardRecommendation.payload.commitment.commitmentNumberId',
      _.get(
        context,
        'grant.payload.commitment.commitmentNumberId',
        _.get(context, [
          'fundingOpportunityData',
          'fundingOpportunityCommitment',
          0,
          'commitmentNumber',
        ])
      )
    )
  );
  if (
    !_.isEmpty(_.toString(commitmentNumber)) &&
    _.isEmpty(_.toString(context.commitment))
  ) {
    return loadDependency('commitment', commitmentNumber, token, optional);
  }
}

function loadComment(data, context, token, optional) {
  const grantId = data.grantId || _.get(context, 'workflowTask.processVariables.grantId');
  const entityType = _.get(context, 'grant.entityType') || ENTITY_PAGE_TYPE_GRANT;
  if (
    !_.isEmpty(_.toString(grantId)) &&
    !_.isEmpty(_.toString(entityType)) &&
    _.isEmpty(_.toString(context.comment))
  ) {
    return loadDependency(
      'comment',
      '?grantId=' + grantId + '&entityType=' + entityType,
      token,
      optional,
      '',
      {
        contextName: 'comment',
      }
    );
  }
}

function loadSubComment(data, context, token, optional, config) {
  let entityType;
  let subAppEntityId;
  if (_.get(data, 'entityType') === 'subApplication') {
    subAppEntityId = _.get(data, 'entityId');
    entityType = _.get(context, 'subApplication.entityType');
  } else if (
    _.get(context, 'subGrant.entityType') === 'subGrant' ||
    _.get(config, 'taskType', _.get(optional, 'taskType')) === 'subGrant'
  ) {
    subAppEntityId = _.get(data, 'subGrantId');
    entityType = _.get(context, 'subGrant.entityType');
  } else {
    subAppEntityId =
      _.get(context, 'workflowTask.processVariables.subApplication.subGrantId') ||
      _.get(context, 'workflowTask.processVariables.entityId');
    entityType = _.get(
      context,
      'subApplication.entityType',
      ENTITY_PAGE_TYPE_SUBAPPLICATION
    );
  }
  if (
    !_.isEmpty(_.toString(subAppEntityId)) &&
    !_.isEmpty(_.toString(entityType)) &&
    _.isEmpty(_.toString(context.subComment))
  ) {
    return loadDependency(
      'subComment',
      '?entityId=' + subAppEntityId + '&entityType=' + entityType,
      token,
      optional,
      '',
      {
        contextName: 'subComment',
      }
    );
  }
}

function loadRFAComment(data, context, token, optional, config) {
  let entityId = _.get(context, 'workflowTask.processVariables.entityId');
  if (!_.isEmpty(_.toString(entityId)) && _.isEmpty(_.toString(context.subComment))) {
    return loadDependency(
      'subComment',
      '?entityId=' + entityId + '&entityType=rfa',
      token,
      optional,
      '',
      {
        contextName: 'subComment',
      }
    );
  }
}

function loadTemplates(data, context, token, optional, config) {
  if (
    _.isEmpty(_.toString(context.templates)) &&
    !_.get(context, 'grant.loading', true) &&
    config &&
    config.templateNames
  ) {
    const params = [
      {name: 'grantId', value: context.grant.grantId},
      {
        name: 'fundingOpportunityId',
        value: context.grant.fundingOpportunityId,
      },
    ];
    const paramString = buildParamString(config.templateNames, params);
    return loadDependency('templates', '?' + paramString, token, optional);
  }
}

function loadRiskAssessment(data, context, token, optional) {
  if (context.workflowTask && context.workflowTask.processVariables) {
    const {programId, grantId} = context.workflowTask.processVariables;
    if (programId && grantId && _.isEmpty(_.toString(context.riskAssessment)))
      return loadDependency(
        'riskAssessment',
        'risks?programId=' + programId + '&grantId=' + grantId,
        token,
        optional
      );
  }
}

function loadWorkflowTask(data, context, token, optional) {
  const taskId = data.taskId;
  if (!_.isEmpty(_.toString(taskId)) && _.isEmpty(_.toString(context.workflowTask))) {
    return loadDependency('workflowTask', taskId, token, optional);
  }
}

function loadScoresV2(data, context, token, optional) {
  const sessionId = _.get(
    context,
    'workflowTask.processVariables.sessionId',
    _.get(context, 'sessionId')
  );
  const entityId = _.get(
    context,
    'workflowTask.processVariables.entityId',
    _.get(context, 'entityId')
  );
  if (sessionId && entityId && _.isEmpty(_.toString(context.panelReviewScoresV2)))
    return loadDependency(
      'panelReviewScoresV2',
      sessionId,
      token,
      optional,
      `/entities/${entityId}/scores`,
      {
        inPayloadObj: true,
      }
    );
}

function loadSessionsV2(data, context, token, optional) {
  const sessions = _.get(context, 'panelReviewV2.sessionEntityScore', []);
  var url = '';
  _.forEach(sessions, (s, i) => {
    const urlParameterType = i === 0 ? '?' : '&';
    return (url += urlParameterType + 'sessionId=' + s.sessionId);
  });

  const scoresLoaded = !_.isNil(_.get(context, 'panelReviewV2.sessionEntityScore'));
  if (scoresLoaded && _.isEmpty(_.toString(context.panelReviewSessionsV2)))
    return loadDependency('panelReviewSessionsV2', url, token, optional, '', {
      inPayloadObj: true,
    });
}

function loadUserScoresV2(data, context, token, optional) {
  if (context.workflowTask) {
    const sessionId = _.get(context, 'workflowTask.processVariables.sessionId');
    const entityId = _.get(context, 'workflowTask.processVariables.entityId');

    const userId = _.get(context, 'auth.userId');
    if (sessionId && entityId && _.isEmpty(_.toString(context.panelReviewUserScoresV2)))
      return loadDependency(
        'panelReviewUserScoresV2',
        sessionId,
        token,
        optional,
        `/entities/${entityId}/scores?userId=${userId}`,
        {
          inPayloadObj: true,
        }
      );
  }
}

function loadFinalScoresV2(data, context, token, optional) {
  const entityId = _.get(
    context,
    'workflowTask.processVariables.entityId',
    _.get(context, 'entityId')
  ); //TODO include sub-grant path for HMA
  if (entityId && _.isEmpty(_.toString(context.panelReviewFinalScoresV2)))
    return loadDependency(
      'panelReviewFinalScoresV2',
      `${entityId}/final-score`,
      token,
      optional,
      '',
      {
        inPayloadObj: true,
      }
    );
}

function loadPanelReview(data, context, token, optional) {
  if (context.workflowTask) {
    const applicationId = _.get(context, 'workflowTask.processVariables.grantId');

    if (applicationId && _.isEmpty(_.toString(context.panelReview)))
      return loadDependency('panelReview', applicationId, token, optional);
  }
}

function loadPanelReviewV2(data, context, token, optional) {
  const grantId = _.get(
    context,
    'workflowTask.processVariables.grantId',
    _.get(context.grant, 'grantId')
  );

  const entityId = grantId + '-application';
  if (grantId && entityId && _.isEmpty(_.toString(context.panelReviewV2))) {
    return loadDependency(
      'panelReviewV2',
      `entities/${entityId}/scores`,
      token,
      optional,
      '',
      {
        contextName: 'panelReviewV2',
      }
    );
  }
}

function loadPrescoreV2(data, context, token, optional) {
  const applicationNumber = _.get(
    context,
    'workflowTask.processVariables.applicationId',
    _.get(context.applicationDynamicData, 'entityId')
  );

  if (applicationNumber && _.isEmpty(_.toString(context.prescoreV2))) {
    return loadDependency('prescoreV2', `/${applicationNumber}`, token, optional, '', {
      inPayloadObj: true,
    });
  }
}

function loadScores(data, context, token, optional) {
  if (context.workflowTask) {
    const grantId = _.get(context, 'workflowTask.processVariables.grantId');

    if (grantId && _.isEmpty(_.toString(context.scores)))
      return loadDependency('scores', grantId, token, optional);
  }
}

function loadFOData(data, context, token, optional) {
  const foID = _.get(
    context,
    'grant.fundingOpportunityId',
    _.get(
      context,
      'workflowTask.processVariables.fundingOpportunityId',
      _.get(
        context,
        'subApplication.fundingOpportunityId',
        _.get(
          context,
          'subGrant.fundingOpportunityId',
          _.get(data, 'fundingOpportunityId')
        )
      )
    )
  );
  if (
    !_.isEmpty(_.toString(foID)) &&
    _.isEmpty(_.toString(context.fundingOpportunityData))
  ) {
    return loadDependency('fundingOpportunityData', foID, token, optional);
  }
}

function loadAwardRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'subGrant.grantId');
  if (
    !_.isEmpty(_.toString(grantId)) &&
    _.isEmpty(_.toString(context.awardRecommendation))
  ) {
    return loadDependency(
      'awardRecommendation',
      `/first-entity?grantId=${grantId}&entityType=awardRecommendation`,
      token,
      optional,
      ''
    );
  }
}

function loadRules(data, context, token, optional, config) {
  const grantId = data.grantId || _.get(context, 'workflowTask.processVariables.grantId');
  if (!_.isEmpty(_.toString(grantId)) && _.isEmpty(_.toString(context.rules))) {
    return loadDependency(
      'rules',
      '',
      token,
      optional,
      `?grantId=${grantId}&rules=${JSON.stringify(config)}`
    );
  }
}

function loadApplicationDynamicData(data, context, token, optional) {
  const grantId =
    data?.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'entityId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');

  if (grantId && _.isEmpty(_.toString(context.applicationDynamicData))) {
    return loadDependency(
      'applicationDynamicData',
      '',
      token,
      optional,
      `/first-entity?grantId=${grantId}&entityType=application`
    );
  }
}

function loadAwardRecommendationDynamicData(data, context, token, optional) {
  const grantId =
    data?.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'entityId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');

  if (grantId && _.isEmpty(_.toString(context.applicationDynamicData))) {
    return loadDependency(
      'applicationDynamicData',
      '',
      token,
      true,
      `/first-entity?grantId=${grantId}&entityType=application`
    );
  }
  if (grantId && _.isEmpty(_.toString(context.awardRecommendationDynamicDataRaw))) {
    return loadDependency(
      'awardRecommendationDynamicDataRaw',
      '',
      token,
      true,
      `first-entity?grantId=${grantId}&entityType=awardRecommendation`
    );
  }

  if (
    grantId &&
    context.applicationDynamicData &&
    !context.applicationDynamicData.loading &&
    context.awardRecommendationDynamicDataRaw &&
    !context.awardRecommendationDynamicDataRaw.loading &&
    _.isEmpty(_.toString(context.awardRecommendationDynamicData))
  ) {
    const appData = context.applicationDynamicData;
    const awardRecommendation = context.awardRecommendationDynamicDataRaw;
    const copyFromPayload = {
      ...appData.payload,
    };
    delete copyFromPayload.budget;
    const payload = {
      ...copyFromPayload,
      ...awardRecommendation.payload,
    };
    const merged = {
      ...awardRecommendation,
      payload,
    };
    return put({
      type: [DYNAMIC_COMPONENT_DEPENDENCY_GET_SUCCESS],
      meta: {objectType: 'awardRecommendationDynamicData', optional},
      payload: merged,
    });
  }
}

function loadPayments(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.payments))) {
    return loadDependency(
      'payments',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=payment`
    );
  }
}

function loadPaymentsForSubGrant(data, context, token, optional) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subGrant.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.paymentsForSubGrant))) {
    return loadDependency(
      'paymentsForSubGrant',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=payment`
    );
  }
}

function loadWorkflowTasksForGrant(data, context, token, optional, config = {}) {
  const grantId = _.get(context, 'grant.grantId');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    !_.isEmpty(_.toString(grantId)) &&
    _.isEmpty(_.toString(context.workflowTasksForGrant))
  ) {
    return loadDependency(
      'workflowTasksForGrant',
      '',
      token,
      optional,
      `?processVariables=grantId_eq_${grantId}&withCandidateGroups=true&includeAssignedTasks=true&withProcessDefinitionKey=true`
    );
  }
}

function loadWorkflowTasksForSubGrant(data, context, token, optional, config = {}) {
  const subGrantId = _.get(context, 'subGrant.subGrantId');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    !_.isEmpty(_.toString(subGrantId)) &&
    _.isEmpty(_.toString(context.workflowTasksForSubGrant))
  ) {
    return loadDependency(
      'workflowTasksForSubGrant',
      '',
      token,
      optional,
      `?processVariables=subGrantId_eq_${subGrantId}&withCandidateGroups=true&includeAssignedTasks=true`
    );
  }
}

function loadWorkflowTasksForSessionEntity(data, context, token, optional, config = {}) {
  const entityId = _.get(context, 'entityId');
  const sessionId = _.get(context, 'sessionId');
  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    !_.isEmpty(_.toString(entityId)) &&
    _.isEmpty(_.toString(context.panelReviewSessionEntityTasks))
  ) {
    return loadDependency(
      'panelReviewSessionEntityTasks',
      '',
      token,
      optional,
      '?extraCols=reviewerList&withCandidateGroups=false',
      {
        inPayloadObj: true,
        contextName: 'panelReviewSessionEntityTasks',
        method: 'POST',
        body: {
          processDefinitionKey: 'panelReview',
          processVariables: [
            {
              name: 'entityId',
              value: entityId,
              operator: 'eq',
            },
            {
              name: 'sessionId',
              value: _.parseInt(sessionId),
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadUserNames(data, context, token, optional, config = {}) {
  if (context.panelReviewSessionEntityTasks) {
    let reviewerIds = _.map(context.panelReviewSessionEntityTasks.payload, (task) => {
      if (typeof task.assignee === 'string') {
        return task.assignee;
      }
    });
    reviewerIds = _.filter(reviewerIds, (reviewer) => {
      if (reviewer) {
        return reviewer;
      }
    });
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      !context.panelReviewReviewerNames &&
      _.isEmpty(_.toString(_.get(context, 'panelReviewReviewerNames'))) &&
      _.get(context, 'panelReviewSessionEntityTasks.loading') === false
    ) {
      return loadDependency('panelReviewReviewerNames', 'users', token, optional, '', {
        contextName: 'panelReviewReviewerNames',
        method: 'POST',
        body: {
          userIds: !_.isEmpty(reviewerIds) ? reviewerIds : [],
        },
      });
    }
  } else if (context.panelReviewReviewer && !context.panelReviewSessionEntityTasks) {
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      !context.panelReviewReviewerNames &&
      _.isEmpty(_.toString(_.get(context, 'panelReviewReviewerNames'))) &&
      _.get(context, 'panelReviewReviewer.loading') === false
    ) {
      let reviewerId = context.panelReviewReviewer.userId;
      return loadDependency('panelReviewReviewerNames', 'users', token, optional, '', {
        contextName: 'panelReviewReviewerNames',
        method: 'POST',
        body: {
          userIds: [reviewerId],
        },
      });
    }
  }
}

function loadWorkflowTasksForSessionUserId(data, context, token, optional, config = {}) {
  const assignee = _.get(context, 'entityId');
  const sessionId = _.get(context, 'sessionId');

  if (
    (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
    !_.isEmpty(_.toString(assignee)) &&
    _.isEmpty(_.toString(context.panelReviewSessionUserTasks))
  ) {
    return loadDependency(
      'panelReviewSessionUserTasks',
      '',
      token,
      optional,
      `?extraCols=entityId,groupId,organizationName`,
      {
        inPayloadObj: true,
        contextName: 'panelReviewSessionUserTasks',
        method: 'POST',
        body: {
          processDefinitionKey: 'panelReview',
          assignee: assignee,
          processVariables: [
            {
              name: 'sessionId',
              value: _.parseInt(sessionId),
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadSessionEntities(data, context, token, optional, config = {}) {
  if (context.panelReviewSessionUserTasks) {
    let entityIds = _.map(context.panelReviewSessionUserTasks.payload, (task) => {
      if (typeof task.entityId === 'string') {
        return task.entityId;
      }
    });
    entityIds = _.compact(_.uniq(entityIds));
    if (
      (!config.femaPermissionsOnly || isFemaUser(context.auth.permissions)) &&
      _.isEmpty(_.toString(_.get(context, 'panelReviewAssignedEntities'))) &&
      _.get(context, 'panelReviewSessionUserTasks.loading') === false
    ) {
      return loadDependency(
        'panelReviewAssignedEntities',
        context.sessionId,
        token,
        optional,
        `/entities?entityId=${!_.isEmpty(entityIds) ? entityIds.toString() : null}`,
        {
          inPayloadObj: true,
        }
      );
    }
  }
}

function loadSubApplicationProgram(data, context, token) {
  if (_.isEmpty(_.toString(context.subApplicationProgram))) {
    const activePrograms = '?status=approved';
    //return loadDependency('subApplicationProgram', subAppId, token);
    const test = loadDependency('subApplicationProgram', activePrograms, token);

    return test;
  }
}

function loadItemCodes(data, context, token) {
  const id = 'items';
  if (_.isEmpty(_.toString(context.loadItemCodes))) {
    return loadDependency('loadItemCodes', id, token);
  }
}
function loadRefApplicantType(data, context, token) {
  const id = 'codes/APPLICATION_TYPE';
  if (_.isEmpty(_.toString(context.loadRefApplicantType))) {
    return loadDependency('loadRefApplicantType', id, token);
  }
}

function loadStates(data, context, token) {
  const id = 'codes/STATE';
  if (_.isEmpty(_.toString(context.loadStates))) {
    return loadDependency('loadStates', id, token);
  }
}

function loadUser(data, context, token, optional) {
  let userId = _.get(context, 'workflowTask.processVariables.submittedUserId');

  if (!_.isEmpty(_.toString(userId)) && _.isEmpty(_.toString(context.user))) {
    return loadDependency('user', `users/${encodeURIComponent(userId)}`, token);
  }
}

function loadAmendment(data, context, token) {
  const amendmentId =
    data.amendmentId || _.get(context, 'workflowTask.processVariables.entityId');

  if (amendmentId && _.isEmpty(_.toString(context.amendment))) {
    return loadDependency('amendment', amendmentId, token);
  }
}
function loadFinancialReport(data, context, token) {
  const financialReportId = _.get(context, 'workflowTask.processVariables.entityId');

  if (financialReportId && _.isEmpty(_.toString(context.financialReport))) {
    return loadDependency('financialReport', financialReportId, token);
  }
}
function loadBSIRReport(data, context, token) {
  const bsirReportId = _.get(context, 'workflowTask.processVariables.entityId');

  if (bsirReportId && _.isEmpty(_.toString(context.bsirReport))) {
    return loadDependency('bsirReport', bsirReportId, token);
  }
}

function loadAmendments(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');

  if (grantId && _.isEmpty(_.toString(context.amendments))) {
    return loadDependency(
      'amendments',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=amendment`
    );
  }
}

function loadPayment(data, context, token) {
  const paymentId =
    data.paymentId || _.get(context, 'workflowTask.processVariables.entityId');

  if (paymentId && _.isEmpty(_.toString(context.payment))) {
    return loadDependency('payment', paymentId, token);
  }
}

function loadEhpEntity(data, context, token, optional) {
  let ehpEntityId =
    _.get(context, 'workflowTask.processVariables.ehpQuestionnaireRecommendationId') ||
    _.get(data, 'payload.ehpEntityId.entityId') ||
    _.get(context, 'subApplication.payload.ehpEntityId.entityId') ||
    _.get(context, 'subApplicationGrant.payload.ehpEntityId.entityId');

  let applicationType =
    _.get(data, 'payload.applicationType') ||
    _.get(context, 'subApplication.payload.applicationType') ||
    _.get(context, 'subApplicationGrant.payload.applicationType');

  let contextObj = 'ehpData';
  if (optional && optional.contextObj) {
    ehpEntityId = _.get(context, optional.entityId);
    contextObj = optional.contextObj;
  }

  const optionalDependent = _.get(optional, 'dependent');
  if (optionalDependent) {
    const dependent = _.get({data, context}, optionalDependent);

    if (dependent && !dependent.loading) {
      if (
        applicationType &&
        applicationType === '232' &&
        ehpEntityId &&
        _.isEmpty(_.toString(context[contextObj]))
      ) {
        return loadDependency(contextObj, ehpEntityId, token, optional);
      }
    }
  } else {
    if (applicationType && _.isEmpty(_.toString(context[contextObj]))) {
      if (applicationType === '232' && ehpEntityId) {
        return loadDependency(contextObj, ehpEntityId, token, optional);
      } else {
        return loadDependency(contextObj, undefined, token, optional);
      }
    }
  }
}

function loadEhpReviewEntity(data, context, token, optional) {
  const workflowTask = _.get(context, 'workflowTask');
  if (workflowTask && workflowTask.loading) {
    return;
  }
  let processVarCheck = _.get(context, 'workflowTask.processVariables.reviewId');

  let reviewId = processVarCheck && processVarCheck !== 'none' ? processVarCheck : false;

  let applicationType =
    _.get(data, 'payload.applicationType') ||
    _.get(context, 'subApplication.payload.applicationType') ||
    _.get(context, 'subApplicationGrant.payload.applicationType');
  const reqAppTypes = ['232', '236'];
  if (applicationType && _.isEmpty(_.toString(context.ehpReviewData))) {
    if (_.includes(reqAppTypes, applicationType) && reviewId) {
      return loadDependency('ehpReviewData', reviewId, token, optional);
    } else {
      return loadDependency('ehpReviewData', '', token, optional);
    }
  }
}

function loadEhpReviewEntityPassthrough(data, context, token, optional) {
  let processVarCheck = _.get(context, 'workflowTask.processVariables.reviewId');

  let reviewId = processVarCheck && processVarCheck !== 'none' ? processVarCheck : false;

  if (
    _.get(context, 'workflowTask.processVariables') &&
    _.isEmpty(_.toString(context.ehpReviewData))
  ) {
    if (reviewId) {
      return loadDependency('ehpReviewData', reviewId, token, optional);
    } else {
      return loadDependency('ehpReviewData', '', token, optional);
    }
  }
}

function loadVendorData(data, context, token, optional) {
  const organization = _.get(context, 'organization');
  const toggles = _.get(context, 'toggles.toggles');
  const isUEIToggled = _.includes(toggles, 'dunsToUEI');
  if (isUEIToggled) {
    const uei = _.get(organization, 'uei', '');
    const eft = _.get(organization, 'eft', '');
    if (
      !_.isEmpty(uei) &&
      !_.isEmpty(_.trim(eft)) &&
      _.isEmpty(_.toString(context.vendor))
    ) {
      return loadDependency('vendor', `?uei=${uei}&eft=${eft}`, token, optional);
    } else if (!_.isEmpty(uei) && _.isEmpty(_.toString(context.vendor))) {
      return loadDependency('vendor', `?uei=${uei}`, token, optional);
    }
  } else {
    const duns =
      _.get(organization, 'duns', '') + '' + (_.get(organization, 'dunsPlus4', '') || '');
    if (!_.isEmpty(duns) && _.isEmpty(_.toString(context.vendor))) {
      return loadDependency('vendor', `?duns=${duns}`, token, optional);
    }
  }
}

function loadFinancialReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.financialReports))) {
    return loadDependency(
      'getForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=financialReport`,
      {
        contextName: 'financialReports',
      }
    );
  }
}

function loadBSIRReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.bsirReports))) {
    return loadDependency(
      'getForGrant',
      `?grantId=${grantId}&entityType=bsirReport`,
      token,
      optional,
      '',
      {
        contextName: 'bsirReports',
      }
    );
  }
}

function loadPerformanceProgressReport(data, context, token) {
  const performanceProgressReportId = _.get(
    context,
    'workflowTask.processVariables.entityId'
  );

  if (
    performanceProgressReportId &&
    _.isEmpty(_.toString(context.performanceProgressReport))
  ) {
    return loadDependency(
      'performanceProgressReport',
      performanceProgressReportId,
      token
    );
  }
}

function loadPerformanceProgressReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.performanceProgressReports))) {
    return loadDependency(
      'getForGrant',
      `?grantId=${grantId}&entityType=performanceProgressReport`,
      token,
      optional,
      '',
      {
        contextName: 'performanceProgressReports',
      }
    );
  }
}

function loadProgrammaticCloseoutReviews(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.programmaticCloseoutReviews))) {
    return loadDependency(
      'getForGrant',
      `?grantId=${grantId}&entityType=programmaticCloseoutReview`,
      token,
      optional,
      '',
      {
        contextName: 'programmaticCloseoutReviews',
      }
    );
  }
}

function loadProgrammaticCloseoutReview(data, context, token, optional) {
  const programmaticCloseoutReviewId =
    _.get(context, 'workflowTask.processVariables.currentProgrammaticCloseoutReviewId') ||
    _.get(context, 'programmaticCloseoutReviews.0.entityId'); //workaround until workflow updates to set/update currentProgrammaticCloseoutReviewId when new task are created
  if (
    programmaticCloseoutReviewId &&
    _.isEmpty(_.toString(context.programmaticCloseoutReview))
  ) {
    return loadDependency(
      'programmaticCloseoutReview',
      programmaticCloseoutReviewId,
      token
    );
  }
}

function loadCloseoutRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');

  if (
    !_.isEmpty(_.toString(grantId)) &&
    _.isEmpty(_.toString(context.closeoutRecommendation))
  ) {
    return loadDependency(
      'closeoutRecommendation',
      `?grantId=${grantId}&entityType=closeoutRecommendation`,
      token,
      optional,
      ''
    );
  }
}

function loadCloseoutReport(data, context, token, optional) {
  const closeoutReportId =
    _.get(context, 'workflowTask.processVariables.closeoutReportId') ||
    _.get(context, 'workflowTask.processVariables.entityId') ||
    _.get(context, 'rfi.payload.parentEntityId');
  if (closeoutReportId && _.isEmpty(_.toString(context.closeoutReport))) {
    return loadDependency('closeoutReport', closeoutReportId, token);
  }
}

function loadCloseoutReports(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId');
  if (grantId && _.isEmpty(_.toString(context.closeoutReports))) {
    return loadDependency(
      'getForGrant',
      `?grantId=${grantId}&entityType=closeoutReport`,
      token,
      optional,
      '',
      {
        contextName: 'closeoutReports',
      }
    );
  }
}

function loadSubCloseoutReport(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (grantId && subGrantId && _.isEmpty(_.toString(context.subCloseoutReport))) {
    return loadDependency(
      'subCloseoutReport',
      '',
      token,
      optional,
      `first-entity?entityType=subCloseoutReport&subGrantId=${subGrantId}`
    );
  }
}

function loadSubCloseoutReports(data, context, token, optional) {
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.subCloseoutReports))) {
    return loadDependency(
      'getForSubGrant',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=subCloseoutReport`,
      {
        contextName: 'subCloseoutReports',
      }
    );
  }
}

function loadSubCloseoutRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (grantId && subGrantId && _.isEmpty(_.toString(context.subCloseoutRecommendation))) {
    return loadDependency(
      'subCloseoutRecommendation',
      '',
      token,
      optional,
      `first-entity?entityType=subCloseoutRecommendation&subGrantId=${subGrantId}`
    );
  }
}

function loadSubAwardRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId') ||
    _.get(context, _.get(optional, 'grantId'));
  const subGrantId =
    _.get(
      data,
      'subGrantId',
      _.get(
        context,
        'workflowTask.processVariables.subGrantId',
        _.get(context, 'workflowTask.processVariables.subApplication.subGrantId')
      )
    ) || _.get(context, _.get(optional, 'subGrantId'));
  if (grantId && subGrantId && _.isEmpty(_.toString(context.subAwardRecommendation))) {
    return loadDependency(
      'subAwardRecommendation',
      '',
      token,
      optional,
      `/first-entity?grantId=${grantId}&entityType=subAwardRecommendation&subGrantId=${subGrantId}`
    );
  }
}

function loadSubAwardOrAmendmentRecommendation(data, context, token, optional) {
  const optionalDependent = _.get(optional, 'dependent');

  const dependent = _.get({data, context}, optionalDependent);
  const dependentValue = _.get(dependent, _.get(optional, 'dependentPath'));

  const entityType = dependentValue
    ? 'subAmendmentRecommendation'
    : 'subAwardRecommendation';

  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');
  const subGrantId = _.get(
    data,
    'subGrantId',
    _.get(
      context,
      'workflowTask.processVariables.subGrantId',
      _.get(context, 'workflowTask.processVariables.subApplication.subGrantId')
    )
  );
  if (
    grantId &&
    subGrantId &&
    (!optionalDependent || (dependent && !dependent.loading)) &&
    _.isEmpty(_.toString(context.subAwardOrAmendmentRecommendation))
  ) {
    return loadDependency(
      'subAwardOrAmendmentRecommendation',
      '',
      token,
      optional,
      `first-entity?grantId=${grantId}&entityType=${entityType}&subGrantId=${subGrantId}`
    );
  }
}

function loadSubAmendmentRecommendation(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');
  const subGrantId = _.get(
    data,
    'subGrantId',
    _.get(
      context,
      'workflowTask.processVariables.subGrantId',
      _.get(
        context,
        'workflowTask.processVariables.subApplication.subGrantId',
        _.get(context, 'subGrant.entityId')
      )
    )
  );
  if (
    grantId &&
    subGrantId &&
    _.isEmpty(_.toString(context.subAmendmentRecommendation))
  ) {
    return loadDependency(
      'subAmendmentRecommendation',
      '',
      token,
      optional,
      `first-entity?grantId=${grantId}&entityType=subAmendmentRecommendation&subGrantId=${subGrantId}`
    );
  }
}

function loadSubAmendmentRecommendationsForSubGrant(data, context, token, optional) {
  const subGrantId =
    data.subGrantId ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subGrant.subGrantId');
  if (
    subGrantId &&
    _.isEmpty(_.toString(context.subAmendmentRecommendationsForSubGrant))
  ) {
    return loadDependency(
      'subAmendmentRecommendationsForSubGrant',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=subAmendmentRecommendation`
    );
  }
}

function loadSubAwardRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subAwardRecommendationsForGrant))) {
    return loadDependency(
      'subAwardRecommendationsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subAwardRecommendation`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadAwardRecommendationForFO(data, context, token, optional) {
  const foId = _.get(data, 'fundingOpportunityId');

  if (foId && _.isEmpty(_.toString(context.awardRecommendationForFO))) {
    return loadDependency(
      'awardRecommendationForFO',
      `?fundingOpportunityId=${foId}&entityType=awardRecommendation`,
      token,
      optional,
      ``
    );
  }
}

function loadSubAwardRecommendationForFO(data, context, token, optional) {
  const foId = _.get(data, 'fundingOpportunityId');

  if (foId && _.isEmpty(_.toString(context.subAwardRecommendationForFO))) {
    return loadDependency(
      'subAwardRecommendationForFO',
      `?fundingOpportunityId=${foId}&entityType=subAwardRecommendation`,
      token,
      optional,
      ``
    );
  }
}

function loadSubAmendmentRecommendationsForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subAmendmentRecommendationsForGrant))) {
    return loadDependency(
      'subAmendmentRecommendationsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=subAmendmentRecommendation`,
      {
        inPayloadObj: true,
      }
    );
  }
}
function loadExternalTasksForGrant(data, context, token, optional, {extraCols} = {}) {
  const grantId = data.grantId || _.get(context, 'grant.grantId');
  if (isFemaUser(context.auth.permissions)) {
    forceSucceedDependency('workflowTasksForGrant');
  } else if (
    !isFemaUser(context.auth.permissions) &&
    !_.isEmpty(_.toString(grantId)) &&
    _.isEmpty(_.toString(context.externalTasksForGrant))
  ) {
    return loadDependency(
      'workflowTasksForGrant',
      '',
      token,
      optional,
      `external?${extraCols != null ? 'extraCols=' + extraCols : ''}`,
      {
        contextName: 'externalTasksForGrant',
        method: 'POST',
        body: {
          candidateGroups: context.auth.permissions,
          includeAssignedTasks: true,
          processVariables: [
            {
              name: 'grantId',
              value: grantId,
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadExternalTasksForSubGrant(data, context, token, optional, {extraCols} = {}) {
  const subGrantId = data.subGrantId || _.get(context, 'subGrant.subGrantId');
  if (isFemaUser(context.auth.permissions)) {
    forceSucceedDependency('workflowTasksForSubGrant');
  } else if (
    !isFemaUser(context.auth.permissions) &&
    !_.isEmpty(_.toString(subGrantId)) &&
    _.isEmpty(_.toString(context.externalTasksForSubGrant))
  ) {
    return loadDependency(
      'workflowTasksForSubGrant',
      '',
      token,
      optional,
      `external?${extraCols != null ? 'extraCols=' + extraCols : ''}`,
      {
        contextName: 'externalTasksForSubGrant',
        method: 'POST',
        body: {
          candidateGroups: context.auth.permissions,
          includeAssignedTasks: true,
          processVariables: [
            {
              name: 'subGrantId',
              value: subGrantId,
              operator: 'eq',
            },
          ],
        },
      }
    );
  }
}

function loadSessionData(data, context, token) {
  if (context.sessionId && _.isEmpty(_.toString(context.panelReviewSession))) {
    return loadDependency('panelReviewSession', context.sessionId, token);
  }
}

function loadSessionEntity(data, context, token, optional) {
  if (
    context.entityId &&
    context.sessionId &&
    _.isEmpty(_.toString(context.panelReviewSessionEntity))
  ) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/entities/${context.entityId}`,
      {
        contextName: 'panelReviewSessionEntity',
      }
    );
  }
}

function loadReviewerData(data, context, token, optional) {
  let entityId = encodeURIComponent(context.entityId);
  if (
    context.entityId &&
    context.sessionId &&
    _.isEmpty(_.toString(context.panelReviewReviewer))
  ) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/reviewers/${entityId}`,
      {
        contextName: 'panelReviewReviewer',
      }
    );
  }
}

function loadPanelReviewAliases(data, context, token, optional) {
  if (context.sessionId && _.isEmpty(_.toString(context.panelReviewAliases))) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      '/configs/aliases',
      {
        contextName: 'panelReviewAliases',
      }
    );
  }
}

function loadPanelGroupData(data, context, token, optional) {
  let groupId = context.entityId;
  if (
    context.entityId &&
    context.sessionId &&
    _.isEmpty(_.toString(context.panelReviewGroup))
  ) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/groups/${groupId}`,
      {
        contextName: 'panelReviewGroup',
      }
    );
  }
}

function loadPanelReviewersGroupData(data, context, token, optional) {
  let sessionId = context.sessionId;
  if (context.sessionId && _.isEmpty(_.toString(context.panelReviewerGroups))) {
    return loadDependency(
      'panelReviewV2Endpoint',
      context.sessionId,
      token,
      optional,
      `/group-names`,
      {
        contextName: 'panelReviewerGroups',
      }
    );
  }
}

function loadRfi(data, context, token, optional) {
  const rfiId =
    (data.entityType === 'rfi' && data.entityId) ||
    _.get(context, 'workflowTask.processVariables.rfiId');
  if (rfiId && _.isEmpty(_.toString(context.rfi))) {
    return loadDependency('rfi', rfiId, token);
  }
}

function loadSubApplicationFromSubGrantId(data, context, token, optional) {
  const subGrantId =
    _.get(data, 'subGrantId') ||
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.subApplicationFromSubGrantId))) {
    return loadDependency(
      'subApplicationFromSubGrantId',
      subGrantId,
      token,
      optional,
      '/entityType/subApplication'
    );
  }
}

function loadRfis(data, context, token, optional) {
  const subGrantId =
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.rfis))) {
    return loadDependency(
      'rfis',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=rfi`
    );
  }
}

function loadRof(data, context, token, optional) {
  const rofId =
    (data.entityType === 'rof' && data.entityId) ||
    _.get(context, 'workflowTask.processVariables.rofId');
  if (rofId && _.isEmpty(_.toString(context.rof))) {
    return loadDependency('rof', rofId, token);
  }
}

function loadRofs(data, context, token, optional) {
  const subGrantId =
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.rofs))) {
    return loadDependency(
      'rofs',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=returnOfFund`
    );
  }
}

function loadRofsForSubGrant(data, context, token, optional) {
  const subGrantId =
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId');
  if (subGrantId && _.isEmpty(_.toString(context.rofsForSubGrant))) {
    return loadDependency(
      'rofsForSubGrant',
      '',
      token,
      optional,
      `?subGrantId=${subGrantId}&entityType=returnOfFund`,
      {
        contextName: 'rofsForSubGrant',
      }
    );
  }
}

function loadRfisForGrant(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');

  if (grantId && _.isEmpty(_.toString(context.rfis))) {
    return loadDependency(
      'rfis',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=rfi`,
      {
        contextName: 'rfis',
      }
    );
  }
}

function loadPanelReviewEntity(data, context, token, optional) {
  const grantId = _.get(context, 'panelReviewSessionEntity.grantId');

  if (grantId && _.isEmpty(_.toString(context.panelReviewEntity))) {
    return loadDependency(
      'panelReviewEntity',
      '',
      token,
      optional,
      `first-entity?grantId=${grantId}&entityType=application`
    );
  }
}

function loadDisasterAreas(data, context, token, optional) {
  if (context && !context.disasterAreas && context.fundingOpportunityData) {
    const dId = context.fundingOpportunityData.disasterNumber;

    if (!_.isEmpty(_.toString(dId))) {
      return loadDependency('disasterAreas', dId, token, false, '/designated-area');
    }
  }
}

function loadDisasterById(data, context, token, optional) {
  const isDisasterFODraft = _.get(
    context,
    'fundingOpportunityDraft.payload.isDisasterFO'
  );
  if (
    (context && !context.disaster && context.fundingOpportunityData) ||
    (context && !context.disaster && isDisasterFODraft)
  ) {
    const dId = isDisasterFODraft
      ? context.fundingOpportunityDraft.payload.disasterNumber
      : context.fundingOpportunityData.disasterNumber;

    if (!_.isEmpty(_.toString(dId))) {
      return loadDependency('disaster', dId, token, false);
    }
  }
}

function loadFundingOpportunityOrganizationData(data, context, token, optional, config) {
  const fundingOpportunityId =
    _.get(data, 'fundingOpportunityId') ||
    _.get(context, 'workflowTask.processVariables.fundingOpportunityId') ||
    _.get(context, 'applicationDynamicData.fundingOpportunityId') ||
    _.get(context, 'subGrant.fundingOpportunityId');
  const organizationId =
    _.get(data, 'organizationId') ||
    _.get(context, 'workflowTask.processVariables.organizationId') ||
    _.get(context, 'applicationDynamicData.organizationId') ||
    _.get(context, 'subGrant.organizationId');
  if (
    !_.isEmpty(_.toString(fundingOpportunityId)) &&
    !_.isEmpty(_.toString(organizationId)) &&
    _.isEmpty(_.toString(context.fundingOpportunityOrganizationData))
  ) {
    return loadDependency(
      'fundingOpportunityOrganizationData',
      `${organizationId}/funding-opportunity-organizations/${fundingOpportunityId}`,
      token,
      optional
    );
  }
}

function loadEhpReviewsForSubGrant(data, context, token, optional) {
  const subGrantId =
    _.get(data, 'subGrantId') ||
    _.get(context, 'workflowTask.processVariables.subGrantId') ||
    _.get(context, 'subApplication.subGrantId') ||
    _.get(context, 'subGrant.subGrantId') ||
    _.get(context, _.get(optional, 'entityId'));

  if (
    !_.isEmpty(_.toString(subGrantId)) &&
    _.isEmpty(_.toString(context.ehpReviewsForSubGrant))
  ) {
    return loadDependency('ehpReviewsForSubGrant', subGrantId, token, optional);
  }
}
function loadFundingOpportunityDraft(data, context, token, optional) {
  if (_.isEmpty(_.toString(context.fundingOpportunityDraft))) {
    const draftId = _.get(data, 'draftFundingOpportunityId');
    return loadDependency('fundingOpportunityDraft', draftId, token, false);
  }
}

function loadsubRecipientMgmtCost(data, context, token, optional, config) {
  return loadDependencyWithParams(
    data,
    context,
    token,
    optional,
    config,
    'subRecipientMgmtCost'
  );
}

function loadSubCloseoutRecommendationForGrant(data, context, token, optional) {
  const grantId =
    _.get(data, 'grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId') ||
    _.get(context, 'application.grantId') ||
    _.get(context, 'applicationDynamicData.grantId') ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId');
  if (grantId && _.isEmpty(_.toString(context.subCloseoutRecommendationForGrant))) {
    return loadDependency(
      'subCloseoutRecommendationForGrant',
      '',
      token,
      optional,
      `first-entity?grantId=${grantId}&entityType=subCloseoutRecommendation`,
      {
        inPayloadObj: true,
      }
    );
  }
}

function loadReturnOfFund(data, context, token, optional) {
  const rofId =
    (data.entityType === 'returnOfFund' && data.entityId) ||
    _.get(context, 'workflowTask.processVariables.rofId');
  if (rofId && _.isEmpty(_.toString(context.returnOfFund))) {
    return loadDependency('returnOfFund', rofId, token);
  }
}
function loadRofsForGrant(data, context, token, optional) {
  const grantId =
    data.grantId ||
    _.get(context, 'grant.grantId') ||
    _.get(context, 'subGrant.grantId') ||
    _.get(context, 'workflowTask.processVariables.grantId');
  if (grantId && _.isEmpty(_.toString(context.rofsForGrant))) {
    return loadDependency(
      'rofsForGrant',
      '',
      token,
      optional,
      `?grantId=${grantId}&entityType=returnOfFund`,
      {
        contextName: 'rofsForGrant',
      }
    );
  }
}
